import { render } from "./QueuedOrders.vue?vue&type=template&id=43ccfbb9&scoped=true"
import script from "./QueuedOrders.vue?vue&type=script&lang=js"
export * from "./QueuedOrders.vue?vue&type=script&lang=js"

import "./QueuedOrders.vue?vue&type=style&index=0&id=43ccfbb9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43ccfbb9"]])

export default __exports__